@if (loading()) {
	<div class="dominos-loader">
		<svg class="dominos-spinner" viewBox="0 0 50 50">
			<circle class="dominos-spinner__circle" cx="25" cy="25" r="20" pathLength="100" />
		</svg>
	</div>
}
